'use client';

import { usePathname as useNextPathname } from 'next/navigation';
const basePath = process.env.NEXT_PUBLIC_BASE_PATH;
if (!basePath) {
  throw new Error('NEXT_PUBLIC_BASE_PATH environment variable is not set');
}

/**
 * Hook that retrieves the current pathname.
 *
 * @returns The current pathname string.
 */
export function usePathname() {
  const pathname = useNextPathname();
  const pathnameWithoutLeadingSlash = pathname.slice(1);
  const [, ...segments] = pathnameWithoutLeadingSlash.split("/");
  return segments.length > 0 ? `${basePath}/${segments.join("/")}` : `${basePath}`;
}